import { render, staticRenderFns } from "./PlatformFunctions.vue?vue&type=template&id=22caa1c9&scoped=true"
import script from "./PlatformFunctions.vue?vue&type=script&lang=js"
export * from "./PlatformFunctions.vue?vue&type=script&lang=js"
import style0 from "./PlatformFunctions.vue?vue&type=style&index=0&id=22caa1c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22caa1c9",
  null
  
)

export default component.exports